/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { sampleProjectTemplateSelectionsControllerReplaceActive } from "./sampleProjectTemplateSelectionsControllerReplaceActive";

export function sampleProjectTemplateSelectionsService() {
  return { sampleProjectTemplateSelectionsControllerReplaceActive }
}